<template>
      <b-modal ref="askForArchiveDataModal" 
              size="lg" 
              centered 
              title="Zgłoś prośbę o dane archiwalne"
              @show="onShow" 
              @hidden="hide">
        <b-container>
          <b-form>
            <b-form-row>
              <b-col md="12">
                <b-alert variant="danger" :show="showAlertDialog">
                  <strong>Uwaga.</strong> Formularz zawiera błędy.
                </b-alert>
              </b-col>
            </b-form-row>
            <b-form-row>
              <b-col md="9" offset="3">
                <small id="topic-empty-error-info" class="text-danger" v-show="archiveDataErrors.topicIsEmpty">Należy podać temat.</small>
              </b-col>
            </b-form-row>
            <b-form-row class="mb-2">
              <b-col md="3">
                <label for="topic" class="col-form-label">Temat</label>
              </b-col>
              <b-col md="9">
                <b-form-input type="text" placeholder="Wpisz temat" maxlength="255" :class="{ 'is-invalid': archiveDataErrors.topicIsEmpty, 'form-control': true }" id="topic" v-model="topic" aria-required="true" :aria-invalid="archiveDataErrors.topicIsEmpty" :aria-describedby="archiveDataErrors.topicIsEmpty ? 'topic-empty-error-info' : ''"/>                   
              </b-col>
            </b-form-row>
            <b-form-row>
              <b-col md="9" offset="3">
                <small id="description-empty-error-info" class="text-danger" v-show="archiveDataErrors.descriptionIsEmpty">Należy podać opis.</small>
              </b-col>
            </b-form-row>
            <b-form-row>
              <b-col md="3">
                <label for="description" class="col-form-label">Opis</label>
              </b-col>
              <b-col md="9">
                <b-form-textarea rows="3" placeholder="Wpisz opis" :class="{ 'is-invalid' : archiveDataErrors.descriptionIsEmpty, 'form-control' : true }" id="description" v-model="description" aria-required="true" :aria-invalid="archiveDataErrors.descriptionIsEmpty" :aria-describedby="archiveDataErrors.descriptionIsEmpty ? 'description-empty-error-info' : ''"></b-form-textarea>
              </b-col>
            </b-form-row>
          </b-form>
        </b-container>
        <div slot="modal-footer" class="w-100">
            <button class="btn float-right ml-2 btn-outline-secondary" @click="hide">Anuluj</button>
            <button class="btn btn-primary float-right" @click="submit">Wyślij</button>
        </div>
    </b-modal>
</template>

<script>
import { WINDOW_ASK_FOR_ARCHIVE_DATA_HIDE } from '../store/mutations.type';
import { Api as ArchiveDataApi } from '../api/api-dane-archiwalne.js'
export default {
  name: "AskForArchiveData",
  data() {
    return {
      topic: "",
      description: "",
      archiveDataErrors: {
        topicIsEmpty: false,
        descriptionIsEmpty: false
      },
      showAlertDialog: false
    }
  },
  created() {
    let self = this;
    self.$store.watch(
        () => self.$store.getters.askForArchiveDataWindowVisible,
        (value, oldValue) => {
            let modal = self.$refs.askForArchiveDataModal;
            let method = value ? modal.show : modal.hide;
            method.call(modal);
        }
    );
  },
  methods: {
    onShow() {
      this.topic = "";
      this.description = "";
      this.showAlertDialog = false;
      this.archiveDataErrors.topicIsEmpty = false;
      this.archiveDataErrors.descriptionIsEmpty = false;
    },
    hide() {
      this.$store.commit(WINDOW_ASK_FOR_ARCHIVE_DATA_HIDE);
    },
    submit() {
      var validated = this.validate();
      if(validated) {
        var self = this;
        var api = new ArchiveDataApi();
        api.postDaneArchiwalne({
          body: {
            Opis: this.description,
            Tytul: this.topic
          }
        }).then(function(response) {
          self.$notify({
            type: 'success',
            title: 'Sukces!',
            text: 'Wysłanie prośby o dane archiwalne zakończone sukcesem.',
            duration: 5000,
          });
        }).catch(function(error){
          self.$notify({
            type: 'error',
            title: 'Uwaga!',
            text: 'Wysłanie prośby o dane archiwalne nie powiodło się.',
            duration: 5000,
          });
        }).finally(function() {
          self.hide();
        });
      }
    },
    validate() {
      this.showAlertDialog = false;
      this.archiveDataErrors.topicIsEmpty = !this.topic;
      this.archiveDataErrors.descriptionIsEmpty = !this.description;

      this.showAlertDialog = this.archiveDataErrors.topicIsEmpty || this.archiveDataErrors.descriptionIsEmpty;

      return !this.showAlertDialog;
    }
  }
}
</script>
